import React from 'react';
import styles from './SectionHeader.module.css';

export default function SectionHeader({ title, subtitle, actions }) {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
